import { ICompanySearchFilter } from "../../Interfaces/ICompanySearchFilter";

/** A search runs from two or more non-blank characters (P.4). */
export const isSearchTermValid = (term: string): boolean =>
  term.trim().length >= 2;

/**
 * Where selecting a result navigates: the tab the client lives on, with a
 * focus parameter so the grid scrolls the row into view and flashes it.
 */
export const getSearchTargetPath = (option: ICompanySearchFilter): string => {
  const base = option.isProspectStage ? "/company/prospects" : "/company";
  return `${base}?focus=${option.companyRowID}`;
};
